import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ReactComponent as YozLogo } from '../../images/YozLogo.svg';
import { ReactComponent as MetaMaskFox } from '../../images/MetaMaskFox.svg';
import { ReactComponent as WalletConnectLogo } from '../../images/WalletConnectLogo.svg';
import { useConnect } from 'wagmi';
import CraButton, { CraButtonClassName } from '../CraButton';

interface WalletConnectModalProps {
  open: boolean;
  onCloseModal: () => void;
}

export default function WalletConnectModal(props: WalletConnectModalProps) {
  const { open, onCloseModal } = props;
  const { connectAsync, connectors } = useConnect();
  const [injectedConnector, walletConnectConnector] = connectors;

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onCloseModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
                <div>
                  <div className="mx-auto flex items-center justify-center">
                    <YozLogo />
                  </div>
                  <div className="mt-3 sm:mt-5">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      Connect wallet
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        Connect with one of our available wallet providers.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6">
                  <CraButton
                    type="button"
                    className={CraButtonClassName}
                    onClick={async () => {
                      connectAsync(injectedConnector);
                      onCloseModal();
                    }}
                  >
                    <MetaMaskFox className="mr-3 h-6 w-6" />
                    <span className="my-auto font-bold">MetaMask</span>
                  </CraButton>
                </div>
                <div className="mt-5 sm:mt-6">
                  <CraButton
                    type="button"
                    className={CraButtonClassName}
                    onClick={async () => {
                      connectAsync(walletConnectConnector);
                      onCloseModal();
                    }}
                  >
                    <WalletConnectLogo className="mr-3 h-6 w-6" />
                    <span className="my-auto font-bold">WalletConnect</span>
                  </CraButton>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
